import { Doughnut } from "vue-chartjs";
import "./plugin.js";

export default {
  extends: Doughnut,
  props: {
    color: String,
    complete: Number
  },
  data: function() {
    return {
      chartdata: {
        labels: ["Completo", "Incompleto"],
        datasets: [
          {
            label: "Data",
            backgroundColor: [this.color, "#37474f"],
            data: [this.complete, 100 - this.complete],
            borderWidth: 0
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        cutoutPercentage: 80,
        tooltips: {
          enabled: false
        },
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            color: "transparent"
          }
        },
        elements: {
          center: {
            text: this.complete + "%",
            color: "#f0f0f0", //Default black
            fontStyle: "Helvetica", //Default Arial
            sidePadding: 15 //Default 20 (as a percentage)
          }
        }
      }
    };
  },

  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  methods: {
    updateData(complete) {
      this.chartdata = {
        ...this.chartdata,
        datasets: [
          {
            ...this.chartdata.datasets[0],
            data: [complete, 100 - complete]
          }
        ]
      };
    },
    updateOptions(complete) {
      this.options = {
        ...this.options,
        elements: {
          center: {
            ...this.options.elements.center,
            text: complete + "%"
          }
        }
      };
    }
  },
  watch: {
    complete: {
      handler() {
        this.updateData(this.complete);
        this.updateOptions(this.complete);
        this.$data._chart.destroy();
        this.renderChart(this.chartdata, this.options);
      }
    }
  }
};
